import script from "./SignatureFIlterSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SignatureFIlterSection.vue?vue&type=script&setup=true&lang=js"

import "./SignatureFIlterSection.vue?vue&type=style&index=0&id=5327fc0d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5327fc0d"]])

export default __exports__